import { Parser, SUPPORTED_FORMULAS } from '@ebit/hot-formula-parser';

export class SeFormulaParser {
    static readonly SUPPORTED_FORMULAS = SUPPORTED_FORMULAS; // An array of formula names

    private _parser;

    constructor() {
        this._parser = new Parser();
        this.setVariable('PI', Math.PI);
        this.setVariable('E', Math.E);
    }

    parse(formula: string): SeFormulaResult {
        return this._parser.parse(formula) as SeFormulaResult;
    }

    setVariable(variableName: string, variableValue: any) {
        this._parser.setVariable(variableName, variableValue);
    }

    getVariable(variableName: string): any {
        return this._parser.getVariable(variableName);
    }

    setFunction(name: string, fn: (...args: any[]) => any) {
        return this._parser.setFunction(name, fn);
    }

    listAllVariables(): any[string] {
        return this._parser.variables;
    }
}

export class SeFormulaResult {
    error: string = '';
    result: any;
}
